module.exports = __webpack_public_path__ + "img/gruverde.13df3b31.png";